import React, { useEffect, useRef, useState } from "react";
import { Form, Image, Button, Modal } from "react-bootstrap";
import "../../../styles/Employees/EmployeePerformance.scss";
import Sorter from "./Sorter";
import { Employee, sortData } from "./utils";
import FilterComponent from "../FilterComponent";
import { commonGetService } from "../../../utils/properties";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setDepartmentListsPerformance, setDesignationListsPerformance, setRangeValueLists1Performance, setRangeValueListsPerformance, setSearchPerformance } from "../../../features/employee/employeePerformanceSlice";

export interface FilterOption {
  filterValue: string;
  isSelect: boolean;
  value?: string;
}

export type RangeValue = [number, number];

// Reusable Close icon matching the Figma design
const CloseIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3536 3.64645C12.5488 3.84171 12.5488 4.15829 12.3536 4.35355L8.7071 8L12.3536 11.6465C12.5488 11.8417 12.5488 12.1583 12.3536 12.3536C12.1583 12.5488 11.8417 12.5488 11.6464 12.3536L8 8.70711L4.35355 12.3536C4.15829 12.5488 3.84171 12.5488 3.64645 12.3536C3.45118 12.1583 3.45118 11.8417 3.64645 11.6464L7.29289 8L3.64645 4.35356C3.45119 4.1583 3.45119 3.84172 3.64645 3.64645C3.84171 3.45119 4.15829 3.45119 4.35355 3.64645L8 7.2929L11.6464 3.64645C11.8417 3.45118 12.1583 3.45118 12.3536 3.64645Z"
      fill="#A0A4A8"
    />
  </svg>
);

const EmployeePerformanceList = () => {

  const dispatch = useAppDispatch();
  const employeePerformanceData = useAppSelector((state) => state.employeePerformance);
  const controllerRef = useRef<AbortController | null>(null);

  const [empData, setEmpData] = useState<Employee[]>([]);
  const [rangeValue, setRangeValue] = useState<RangeValue>([0, 100]);
  const [rangeValue1, setRangeValue1] = useState<RangeValue>([0, 100]);
  const [departmentOptions, setDepartmentOptions] = useState<FilterOption[]>(
    []
  );
  const [designationOptions, setDesignationOptions] = useState<FilterOption[]>(
    []
  );
  const [designationSelected, setDesignationSelected] = useState<string[]>([]);
  const [departmentSelected, setDepartmentSelected] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchText, setSearchText] = useState<string>(employeePerformanceData?.search || "");

  // Tablet filter modal state
  const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  // Temp state for modal
  const [tempDepartmentOptions, setTempDepartmentOptions] = useState<
    FilterOption[]
  >([]);
  const [tempDesignationOptions, setTempDesignationOptions] = useState<
    FilterOption[]
  >([]);
  const [tempRangeValue, setTempRangeValue] = useState<RangeValue>([0, 100]);
  const [tempRangeValue1, setTempRangeValue1] = useState<RangeValue>([0, 100]);


  const openFilterModal = () => {
    setTempDepartmentOptions(departmentOptions.map((o) => ({ ...o })));
    setTempDesignationOptions(designationOptions.map((o) => ({ ...o })));
    setTempRangeValue([...rangeValue]);
    setTempRangeValue1([...rangeValue1]);
    setOpenDropdown(null);
    setShowFilterModal(true);
  };

  const handleModalCancel = () => {
    setShowFilterModal(false);
    setOpenDropdown(null);
  };

  const handleModalApply = () => {
    setDepartmentOptions(tempDepartmentOptions);
    setDesignationOptions(tempDesignationOptions);
    setRangeValue(tempRangeValue);
    setRangeValue1(tempRangeValue1);

    setDepartmentSelected(
      tempDepartmentOptions
        .filter((o) => o.isSelect)
        .map((o) => o.value)
        .filter((v): v is string => v !== undefined)
    );
    let list = tempDepartmentOptions.filter((o) => o.isSelect).map((o) => o.value);
    dispatch(setDepartmentListsPerformance(list as string[]));
    setDesignationSelected(
      tempDesignationOptions
        .filter((o) => o.isSelect)
        .map((o) => o.value)
        .filter((v): v is string => v !== undefined)
    );
    let list1 = tempDesignationOptions.filter((o) => o.isSelect).map((o) => o.value);
    dispatch(setDesignationListsPerformance(list1 as string[]));

    setShowFilterModal(false);
    setOpenDropdown(null);
  };

  const handleModalClearAll = () => {
    setTempDepartmentOptions((prev) =>
      prev.map((o) => ({ ...o, isSelect: false }))
    );
    setTempDesignationOptions((prev) =>
      prev.map((o) => ({ ...o, isSelect: false }))
    );
    setTempRangeValue([0, 100]);
    setTempRangeValue1([0, 100]);
    dispatch(setRangeValueListsPerformance([0, 100]));
    dispatch(setRangeValueLists1Performance([0, 100]));
    dispatch(setDepartmentListsPerformance([]));
    dispatch(setDesignationListsPerformance([]));
  };

  const handleData = (val: RangeValue) => {
    setRangeValue(val);
    dispatch(setRangeValueListsPerformance(val));
  };
  const handleData1 = (val: RangeValue) => {
    setRangeValue1(val);
    dispatch(setRangeValueLists1Performance(val));

  };
  const handleSort = (field: keyof Employee, order: string) => {
    setEmpData((prev) => sortData(prev, field, order));
  };
  const handleClearAll = () => {
    setDepartmentOptions((prev) =>
      prev.map((o) => ({ ...o, isSelect: false }))
    );
    setDesignationOptions((prev) =>
      prev.map((o) => ({ ...o, isSelect: false }))
    );
    setDepartmentSelected([]);
    setDesignationSelected([]);
    setRangeValue([0, 100]);
    setRangeValue1([0, 100]);
    dispatch(setRangeValueListsPerformance([0, 100]));
    dispatch(setRangeValueLists1Performance([0, 100]));
    dispatch(setDepartmentListsPerformance([]));
    dispatch(setDesignationListsPerformance([]));
  };

  const isDefaultRange = (range: RangeValue) =>
    range[0] === 0 && range[1] === 100;

  const showClearAll =
    employeePerformanceData?.departmentLists.length > 0 ||
    employeePerformanceData?.designationLists.length > 0 ||
    !isDefaultRange(employeePerformanceData?.rangeValue) ||
    !isDefaultRange(employeePerformanceData?.rangeValue1);

  const hasActiveFilters =
    employeePerformanceData?.departmentLists.length > 0 ||
    employeePerformanceData?.designationLists.length > 0 ||
    !isDefaultRange(employeePerformanceData?.rangeValue) ||
    !isDefaultRange(employeePerformanceData?.rangeValue1);

  const activeFilterCount =
    employeePerformanceData?.departmentLists.length +
    employeePerformanceData?.designationLists.length +
    (!isDefaultRange(employeePerformanceData?.rangeValue) ? 1 : 0) +
    (!isDefaultRange(employeePerformanceData?.rangeValue1) ? 1 : 0);

  const tableRows = empData.filter((emp) => {
    return (
      emp.employee_id.toString().includes(searchText) ||
      emp.employee_name.toLowerCase().includes(searchText.toLowerCase()) ||
      emp.department.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  // Toggle open/close a dropdown panel
  const toggleDropdown = (key: string) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
  };

  // Toggle a single checkbox in temp state
  const toggleTempOption = (
    setter: React.Dispatch<React.SetStateAction<FilterOption[]>>,
    key: "value" | "filterValue",
    keyVal: string
  ) => {
    setter((prev) =>
      prev.map((o) =>
        (key === "value" ? o.value : o.filterValue) === keyVal
          ? { ...o, isSelect: !o.isSelect }
          : o
      )
    );
  };

  // Reusable dropdown-with-checkboxes component for modal
  const FilterDropdown = ({
    id,
    label,
    placeholder,
    options,
    setter,
    optionKey,
  }: {
    id: string;
    label: string;
    placeholder: string;
    options: FilterOption[];
    setter: React.Dispatch<React.SetStateAction<FilterOption[]>>;
    optionKey: "value" | "filterValue";
  }) => {
    const isOpen = openDropdown === id;
    const selectedItems = options.filter((o) => o.isSelect);
    const selectedCount = selectedItems.length;

    const removeChip = (e: React.MouseEvent, keyVal: string) => {
      e.stopPropagation();
      toggleTempOption(setter, optionKey, keyVal);
    };

    return (
      <Form.Group className="mb-3 filter-dropdown-group">
        <Form.Label>{label}</Form.Label>
        <div className={`filter-dropdown${isOpen ? " open" : ""}`}>
          <button
            type="button"
            className="filter-dropdown-trigger"
            onClick={() => toggleDropdown(id)}
          >
            {selectedCount > 0 ? (
              <span className="chips-wrapper">
                {selectedItems.map((o) => {
                  const keyVal =
                    optionKey === "value" ? o.value ?? "" : o.filterValue;
                  return (
                    <span key={keyVal} className="chip">
                      <span className="chip-label">{o.filterValue}</span>
                      <span
                        className="chip-remove"
                        onClick={(e) => removeChip(e, keyVal)}
                      >
                        <CloseIcon size={16} />
                      </span>
                    </span>
                  );
                })}
              </span>
            ) : (
              <span className="trigger-text">{placeholder}</span>
            )}
            <span className="trigger-right">
              <svg
                className={`dropdown-chevron${isOpen ? " rotated" : ""}`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M4 6L8 10L12 6"
                  stroke="#6d6d6d"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>

          {isOpen && (
            <div className="filter-dropdown-panel">
              {options.length === 0 ? (
                <p className="no-options-text">No options available</p>
              ) : (
                options.map((o) => {
                  const keyVal =
                    optionKey === "value" ? o.value ?? "" : o.filterValue;
                  return (
                    <label
                      key={keyVal}
                      className={`dropdown-checkbox-row${o.isSelect ? " checked" : ""
                        }`}
                      onClick={() =>
                        toggleTempOption(setter, optionKey, keyVal)
                      }
                    >
                      <span
                        className={`custom-checkbox${o.isSelect ? " checked" : ""
                          }`}
                      >
                        {o.isSelect && (
                          <svg
                            width="10"
                            height="8"
                            viewBox="0 0 10 8"
                            fill="none"
                          >
                            <path
                              d="M1 4L3.5 6.5L9 1"
                              stroke="#fff"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </span>
                      <span className="dropdown-checkbox-label">
                        {o.filterValue}
                      </span>
                    </label>
                  );
                })
              )}
            </div>
          )}
        </div>
      </Form.Group>
    );
  };

  // Range dropdown for modal — dual-thumb slider with green fill between thumbs
  const RangeDropdown = ({
    id,
    label,
    range,
    onChange,
  }: {
    id: string;
    label: string;
    range: RangeValue;
    onChange: (val: RangeValue) => void;
  }) => {
    const isOpen = openDropdown === id;
    const isDefault = range[0] === 0 && range[1] === 100;
    const summaryText = isDefault
      ? "Select Range"
      : `${range[0]}% – ${range[1]}%`;

    const leftPct = range[0];
    const rightPct = range[1];

    const trackStyle: React.CSSProperties = {
      background: `linear-gradient(
        to right,
        #d7d8dc ${leftPct}%,
        #4caf50 ${leftPct}%,
        #4caf50 ${rightPct}%,
        #d7d8dc ${rightPct}%
      )`,
    };

    const leftLabelStyle: React.CSSProperties = {
      left: `calc(${leftPct}% + ${8 - leftPct * 0.16}px)`,
      transform: "translateX(-50%)",
    };
    const rightLabelStyle: React.CSSProperties = {
      left: `calc(${rightPct}% + ${8 - rightPct * 0.16}px)`,
      transform: "translateX(-50%)",
    };

    return (
      <Form.Group className="mb-3 filter-dropdown-group">
        <Form.Label>{label}</Form.Label>
        <div className={`filter-dropdown${isOpen ? " open" : ""}`}>
          <button
            type="button"
            className="filter-dropdown-trigger"
            onClick={() => toggleDropdown(id)}
          >
            <span
              className={`trigger-text${!isDefault ? " has-selection" : ""}`}
            >
              {summaryText}
            </span>
            <span className="trigger-right">
              <svg
                className={`dropdown-chevron${isOpen ? " rotated" : ""}`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M4 6L8 10L12 6"
                  stroke="#6d6d6d"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>

          {isOpen && (
            <div className="filter-dropdown-panel range-panel">
              <div className="dual-range-wrapper">
                <div className="dual-range-track-area">
                  <div className="dual-range-track" style={trackStyle} />
                  <input
                    type="range"
                    min={0}
                    max={100}
                    value={range[0]}
                    className="range-input range-from"
                    onChange={(e) => {
                      const val = Math.min(
                        Number(e.target.value),
                        range[1] - 1
                      );
                      onChange([val, range[1]]);
                    }}
                  />
                  <input
                    type="range"
                    min={0}
                    max={100}
                    value={range[1]}
                    className="range-input range-to"
                    onChange={(e) => {
                      const val = Math.max(
                        Number(e.target.value),
                        range[0] + 1
                      );
                      onChange([range[0], val]);
                    }}
                  />
                </div>

                <div className="dual-range-labels">
                  <span className="range-thumb-label" style={leftLabelStyle}>
                    {range[0]}%
                  </span>
                  <span className="range-thumb-label" style={rightLabelStyle}>
                    {range[1]}%
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </Form.Group>
    );
  };

  useEffect(() => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;
    let endpoint = `/api/1.0/employee/performance`;

    if (designationSelected.length > 0) {
      endpoint += `${endpoint.includes("?") ? "&" : "?"
        }designation_ids=${designationSelected.join(",")}`;
    }
    if (departmentSelected.length > 0) {
      endpoint += `${endpoint.includes("?") ? "&" : "?"
        }department_ids=${departmentSelected.join(",")}`;
    }
    if (!(rangeValue[0] === 0 && rangeValue[1] === 100)) {
      endpoint += `${endpoint.includes("?") ? "&" : "?"}productivityRangeFrom=${rangeValue[0]
        }&productivityRangeTo=${rangeValue[1]}`;
    }
    if (!(rangeValue1[0] === 0 && rangeValue1[1] === 100)) {
      endpoint += `${endpoint.includes("?") ? "&" : "?"
        }unproductivityRangeFrom=${rangeValue1[0]}&unproductivityRangeTo=${rangeValue1[1]
        }`;
    }

    commonGetService(endpoint, signal).then((res) => {
      if (res.status === 200) {
        setEmpData(res.data);
        setIsLoading(false);
      } else if (res.status !== "cancelled") {
        setIsLoading(false);
      }
    });
  }, [designationSelected, departmentSelected, rangeValue, rangeValue1]);

  useEffect(() => {
    commonGetService(`/api/1.0/role/departments`).then((res) => {
      if (res.status === 200) {
        let options: FilterOption[] = [];
        res.data.forEach((item: any) => {
          options.push({
            filterValue: item.label,
            isSelect: false,
            value: item.value,
          });
        });
        if (employeePerformanceData?.departmentLists.length > 0) {
          options.map((item: any) => {
            employeePerformanceData?.departmentLists.includes(item.value) && (item.isSelect = true)
          })
          setDepartmentSelected(options.filter((o) => o.isSelect).map((o) => o.value).filter((v): v is string => v !== undefined))

        }
        setDepartmentOptions(options);
      } else {
        setDepartmentOptions([]);
      }
    });
    commonGetService(`/api/1.0/employee/designations`).then((res) => {
      if (res.status === 200) {
        let options: FilterOption[] = [];
        res.data.forEach((item: any) => {
          options.push({
            filterValue: item.label,
            isSelect: false,
            value: item.value,
          });
        });
        if (employeePerformanceData?.designationLists.length > 0) {
          options.map((item: any) => {
            employeePerformanceData?.designationLists.includes(item.value) && (item.isSelect = true)
          })
          setDesignationSelected(options.filter((o) => o.isSelect).map((o) => o.value).filter((v): v is string => v !== undefined))
        }
        setDesignationOptions(options);
      } else {
        setDesignationOptions([]);
      }
    });
    setRangeValue(employeePerformanceData?.rangeValue);
    setRangeValue1(employeePerformanceData?.rangeValue1);
  }, []);

  return (
    <div className="emp-container">
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center h-100 w-100 crt-loader">
          <img src="/images/loader/content_loader.gif" />
        </div>
      ) : (
        <div className="list-emp-contaniner d-flex flex-column">
          <div className="d-flex flex-column">
            {/* Header row */}
            <div className="d-flex justify-content-between align-items-center">
              <h3>Employee Performance</h3>
              <Button
                className="export-btn-list-emp desktop-export-btn custom-export-btn"
                disabled={true}
              >
                <Image
                  src="/images/employees/download_icon.svg"
                  alt="Download"
                />
                Export
              </Button>
            </div>

            {/* Search bar + tablet actions */}
            <div className="search-and-actions mt-4">
              <div className="search-bar">
                <Form.Control
                  type="text"
                  placeholder="Search employees by name, ID, or department"
                  value={searchText}
                  name="employee-filter"
                  onChange={(e) => { setSearchText(e.target.value); dispatch(setSearchPerformance(e.target.value)) }}
                />
                <Image
                  src="/images/dashboard/grey_search.svg"
                  alt="Search_Icon"
                  className="position-absolute"
                />
              </div>

              {/* Tablet-only action buttons */}
              <div className="tablet-actions">
                <Button className="tablet-filter-btn" onClick={openFilterModal}>
                  <Image src="/images/employees/filtericon.svg" alt="Filter" />
                  Filter
                  {hasActiveFilters && (
                    <span className="filter-badge">{activeFilterCount}</span>
                  )}
                </Button>
                <Button
                  className="export-btn-list-emp custom-export-btn"
                  disabled={true}
                >
                  <Image
                    src="/images/employees/download_icon.svg"
                    alt="Download"
                  />
                  Export
                </Button>
              </div>
            </div>

            {/* Desktop-only inline filters */}
            <div className="fltr-fld-cont desktop-filters">
              <div className="fltr-fld">
                <FilterComponent
                  filterBy="Department"
                  filterTitle="Select Department"
                  filterOptions={departmentOptions}
                  filterType="checkbox"
                  onApply={(updatedOptions) => {
                    setDepartmentOptions([...updatedOptions]);
                    const selectedDepartments = updatedOptions
                      .filter((o) => o.isSelect)
                      .map((o) => o.value)
                      .filter((v): v is string => v !== undefined);
                    setDepartmentSelected(selectedDepartments);
                    dispatch(setDepartmentListsPerformance(selectedDepartments));
                  }}
                />
                <FilterComponent
                  filterBy="Designation"
                  filterTitle="Select Designation"
                  filterOptions={designationOptions}
                  filterType="checkbox"
                  onApply={(updatedOptions) => {
                    setDesignationOptions([...updatedOptions]);
                    const selectedDepartments = updatedOptions
                      .filter((o) => o.isSelect)
                      .map((o) => o.value)
                      .filter((v): v is string => v !== undefined);
                    setDesignationSelected(selectedDepartments);
                    dispatch(setDesignationListsPerformance(selectedDepartments));

                  }}
                />
                <FilterComponent
                  filterBy="Productivity Rate"
                  filterTitle="Select Range"
                  filterType="range"
                  rangeValue={rangeValue}
                  handleData={handleData}
                />
                <FilterComponent
                  filterBy="Unproductivity Rate"
                  filterTitle="Select Range"
                  filterType="range"
                  rangeValue={rangeValue1}
                  handleData={handleData1}
                />
              </div>

              {showClearAll && (
                <div className="clr-txt" onClick={handleClearAll}>
                  Clear All
                </div>
              )}
            </div>
          </div>

          {/* Table */}
          <div className="emp-list w-100 common-scroll mx-auto styled-scroll-hor">
            <table className="w-100">
              <thead>
                <tr>
                  <th>
                    <div className="d-flex">
                      Emp ID
                      <Sorter
                        onClick={(val) => handleSort("employee_id", val)}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Employee
                      <Sorter
                        onClick={(val) => handleSort("employee_name", val)}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Department
                      <Sorter
                        onClick={(val) => handleSort("department", val)}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Designation
                      <Sorter
                        onClick={(val) => handleSort("designation", val)}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Total Logged Hours
                      <Sorter
                        onClick={(val) => handleSort("total_time", val)}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Productive Hours
                      <Sorter
                        onClick={(val) => handleSort("productive_time", val)}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Productivity Rate
                      <Sorter
                        onClick={(val) =>
                          handleSort("productive_percentage", val)
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Unproductive Hours
                      <Sorter
                        onClick={(val) => handleSort("unproductive_time", val)}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex">
                      Unproductivity Rate
                      <Sorter
                        onClick={(val) =>
                          handleSort("unproductive_percentage", val)
                        }
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="common-scroll">
                {tableRows.length ? (
                  tableRows.map((item) => (
                    <tr key={item.employee_id}>
                      <td>{item.employee_id}</td>
                      <td>
                        <div className="d-flex">
                          {item.employee_image ? (
                            <div className="image-wrapper">
                              <Image
                                src={item.employee_image}
                                alt="emp"
                                className="emp-img"
                                key={item.employee_image}
                              />
                            </div>
                          ) : (
                            <div
                              className={
                                item.employee_image
                                  ? "pro-pic"
                                  : "pro-pic fill-color-avatar"
                              }
                            >
                              {" "}
                              <span>
                                {item.employee_name.charAt(0).toUpperCase()}
                              </span>
                            </div>
                          )}
                          <span>
                            <p
                              className="emp-name performance"
                              title={item.employee_name}
                            >
                              {item.employee_name}
                            </p>
                            <p
                              title={item.employee_mail}
                              className="performance"
                            >
                              {item.employee_mail}
                            </p>
                          </span>
                        </div>
                      </td>
                      <td title={item.department}>{item.department}</td>
                      <td title={item.designation}>{item.designation}</td>
                      <td>{item.total_time}</td>
                      <td>{item.productive_time}</td>
                      <td
                        className={`percentage ${item.productive_percentage >= "70"
                          ? "green"
                          : item.productive_percentage < "70" &&
                            item.productive_percentage >= "50"
                            ? ""
                            : "red"
                          }`}
                      >
                        {item.productive_percentage} %
                      </td>
                      <td>{item.unproductive_time}</td>
                      <td
                        className={`percentage ${item.unproductive_percentage >= "50"
                          ? "red"
                          : item.unproductive_percentage < "50" &&
                            item.unproductive_percentage >= "30"
                            ? ""
                            : "green"
                          }`}
                      >
                        {item.unproductive_percentage} %
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="no-data-row">
                    <td className="no-data" colSpan={9}>
                      <div className="d-flex flex-column justify-content-center align-items-center">
                        <Image
                          src="/images/dashboard/user_icon.png"
                          alt="No Data Found"
                        />
                        <p
                          className="m-0"
                          style={{
                            margin: "1.5rem !important",
                            textAlign: "center",
                          }}
                        >
                          No users to show
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── Tablet Filter Modal ── */}
      <Modal
        show={showFilterModal}
        onHide={handleModalCancel}
        centered
        className="tablet-filter-modal"
      >
        <Modal.Header>
          <Modal.Title>Filter</Modal.Title>
          {/* Modal close button uses the Figma Close icon */}
          <button className="modal-close-btn" onClick={handleModalCancel}>
            <CloseIcon size={16} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <FilterDropdown
            id="department"
            label="Department"
            placeholder="Select Department"
            options={tempDepartmentOptions}
            setter={setTempDepartmentOptions}
            optionKey="value"
          />
          <FilterDropdown
            id="designation"
            label="Designation"
            placeholder="Select Designation"
            options={tempDesignationOptions}
            setter={setTempDesignationOptions}
            optionKey="value"
          />
          <RangeDropdown
            id="productivityRange"
            label="Productivity Rate"
            range={tempRangeValue}
            onChange={(val) => setTempRangeValue(val)}
          />
          <RangeDropdown
            id="unproductivityRange"
            label="Unproductivity Rate"
            range={tempRangeValue1}
            onChange={(val) => setTempRangeValue1(val)}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-footer-left">
            {(tempDepartmentOptions.some((o) => o.isSelect) ||
              tempDesignationOptions.some((o) => o.isSelect) ||
              !(tempRangeValue[0] === 0 && tempRangeValue[1] === 100) ||
              !(tempRangeValue1[0] === 0 && tempRangeValue1[1] === 100)) && (
                <span className="modal-clear-all" onClick={handleModalClearAll}>
                  Clear All
                </span>
              )}
          </div>
          <div className="modal-footer-actions">
            <Button className="modal-cancel-btn" onClick={handleModalCancel}>
              Cancel
            </Button>
            <Button className="modal-apply-btn" onClick={handleModalApply}>
              Apply
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EmployeePerformanceList;
